export enum TipoReciboEnum {

  RETENCAO = "Retenção de tributos",
  NOTA_AVULSA = "Nota fiscal avulsa"
}
